<template>
  <div class="my-comments-page">
    <div class="page-header">
      <h1>
        <svg class="title-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        我的评论
      </h1>
      <p>查看你发表过的评论和回复</p>
    </div>

    <div v-if="loading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <div v-else-if="comments.length === 0" class="empty-state">
      <svg class="empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      <p>还没有发表过评论</p>
      <button @click="goHome" class="btn-primary">去首页看看</button>
    </div>

    <div v-else class="comments-list">
      <div v-for="comment in comments" :key="comment.id" class="comment-card">
        <div v-if="comment.comic" class="comic-info" @click="goToComic(comment.comic.id)">
          <img :src="comment.comic.cover || '/logo.png'" class="comic-cover" alt="封面" />
          <span class="comic-title">{{ comment.comic.title }}</span>
        </div>
        <div class="comment-body">
          <div class="comment-meta">
            <span class="comment-time">{{ comment.time_text }}</span>
            <button @click="deleteComment(comment.id)" class="delete-btn">删除</button>
          </div>
          <div v-if="comment.rating > 0" class="comment-rating">
            <svg v-for="i in 5" :key="i" class="star" :class="{ 'filled': i <= comment.rating }" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          </div>
          <p class="comment-content">{{ comment.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyComments, deleteCommentApi } from '../api/index';

export default {
  name: 'MyCommentsPage',
  data() {
    return {
      loading: true,
      comments: []
    };
  },
  mounted() {
    this.loadComments();
  },
  methods: {
    async loadComments() {
      this.loading = true;
      try {
        const res = await getMyComments({ page: 1, limit: 50 });
        if (res.data && res.data.code === 1) {
          this.comments = res.data.data.list || [];
        }
      } catch (e) {
        console.error('加载我的评论失败:', e);
      } finally {
        this.loading = false;
      }
    },

    async deleteComment(commentId) {
      if (!confirm('确定要删除这条评论吗？')) return;
      try {
        const res = await deleteCommentApi(commentId);
        if (res.data && res.data.code === 1) {
          this.comments = this.comments.filter(c => c.id !== commentId);
        }
      } catch (e) {
        console.error('删除评论失败:', e);
        alert('删除失败');
      }
    },

    goToComic(comicId) {
      this.$router.push(`/comic/${comicId}`);
    },

    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped>
.my-comments-page {
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--text);
}

.page-header {
  text-align: center;
  margin-bottom: 24px;
  padding: 22px 24px;
  background: linear-gradient(135deg, var(--brand-deep) 0%, var(--brand) 100%);
  color: #fff;
  border-radius: 8px;
}

.page-header h1 {
  margin: 0 0 8px 0;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.page-header p {
  margin: 0;
  opacity: 0.9;
  font-size: 13px;
}

.title-svg {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.loading-state,
.empty-state {
  text-align: center;
  padding: 50px 20px;
  color: var(--text-dim);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--surface-3);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.empty-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.comments-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.comment-card {
  display: flex;
  gap: 14px;
  padding: 14px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 8px;
}

.comic-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 90px;
  flex-shrink: 0;
  cursor: pointer;
}

.comic-cover {
  width: 80px;
  height: 106px;
  object-fit: cover;
  border-radius: 5px;
}

.comic-title {
  font-size: 12px;
  color: var(--text);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.comment-body {
  flex: 1;
  min-width: 0;
}

.comment-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.comment-time {
  font-size: 12px;
  color: var(--text-dim);
}

.delete-btn {
  background: transparent;
  color: var(--danger);
  border: 1px solid var(--danger);
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.delete-btn:hover {
  background: var(--danger);
  color: #fff;
}

.comment-rating {
  display: flex;
  gap: 2px;
  margin-bottom: 8px;
}

.star {
  width: 14px;
  height: 14px;
  color: var(--text-dim);
}

.star.filled {
  color: #fbbf24;
}

.comment-content {
  margin: 0;
  font-size: 14px;
  color: var(--text);
  line-height: 1.6;
  word-break: break-word;
}

.btn-primary {
  background: var(--brand);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: var(--brand-hover);
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .my-comments-page {
    margin: 10px;
    padding: 15px;
  }

  .comment-card {
    flex-direction: column;
  }

  .comic-info {
    flex-direction: row;
    width: 100%;
  }

  .comic-cover {
    width: 50px;
    height: 66px;
  }
}
</style>
